module.exports = __webpack_public_path__ + "img/iptu-2025-1.d9eb26ec.jpg";